/**
 * @generated SignedSource<<225ca7792ccd7e0fbcf0e65f18f385ac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AddClientsInput = {
  clientMutationId?: string | null | undefined;
  emails: ReadonlyArray<string | null | undefined>;
};
export type InviteDialogAddClientsMutation$variables = {
  input: AddClientsInput;
};
export type InviteDialogAddClientsMutation$data = {
  readonly addClients: {
    readonly invites: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PendingInviteItem_invite">;
    }>;
    readonly problems: ReadonlyArray<{
      readonly code: string;
      readonly message: string;
    }>;
  } | null | undefined;
};
export type InviteDialogAddClientsMutation = {
  response: InviteDialogAddClientsMutation$data;
  variables: InviteDialogAddClientsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Problem",
  "kind": "LinkedField",
  "name": "problems",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InviteDialogAddClientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddClientsPayload",
        "kind": "LinkedField",
        "name": "addClients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Invite",
            "kind": "LinkedField",
            "name": "invites",
            "plural": true,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PendingInviteItem_invite"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InviteDialogAddClientsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddClientsPayload",
        "kind": "LinkedField",
        "name": "addClients",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Invite",
            "kind": "LinkedField",
            "name": "invites",
            "plural": true,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "email",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "source",
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "format",
                    "value": "MMMM Do"
                  }
                ],
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": "createdAt(format:\"MMMM Do\")"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "client",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientStatus",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b964e5e800d6bd04e12cedb627971a7d",
    "id": null,
    "metadata": {},
    "name": "InviteDialogAddClientsMutation",
    "operationKind": "mutation",
    "text": "mutation InviteDialogAddClientsMutation(\n  $input: AddClientsInput!\n) {\n  addClients(input: $input) {\n    invites {\n      ...PendingInviteItem_invite\n      id\n    }\n    problems {\n      code\n      message\n    }\n  }\n}\n\nfragment PendingInviteItem_invite on Invite {\n  id\n  email\n  source\n  createdAt(format: \"MMMM Do\")\n  client {\n    id\n    clientStatus\n  }\n}\n"
  }
};
})();

(node as any).hash = "54e12c1afd446551f7f1be378df6a252";

export default node;
